export default __webpack_public_path__ + "static/media/RUCRECEPTOR.6226f02e.gif";